const en = {
  // Common
  back: "Back",
  format: "Format",
  searchByNameEmailTitle: "Search by name, last name, email, course title",
  searchByNameOrEmail: "Search by name or email",
  searchUsers: "Search Users",
  close: "Close",

  /*Menu Items */
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  levelOfAccess: "Level of Access",
  status: "Status",
  export: "Export",
  exportCertificates: "Export Certificates",
  exportCompletions: "Export Completions",
  exportEnrollments: "Export Enrollments",
  import: "Import",
  addUser: "Add User",
  fetchError: "Error fetching data...",
  users: "Users",
  enrollments: "Enrollments",
  completions: "Completions",
  noCompletionsFound: "No completions found for your search",
  unauthorizedLabel: "Unauthorized",
  unauthorizedMessage: "You're not allowed to access this resource",
  importUsers: "Import Users",
  importUsersSuccessMessage:
    "The file was imported successfully. Users who were included in the file will be notified shortly. You can now close this dialog.",
  bulkUploadFileContentError:
    "There was an error processing the file. Please refresh and try again",
  uploadNewFile: "Upload new file",

  accessLevelImportWarningMessage:
    "All users uploaded will be assigned the same Access Level.",
  downloadCsvTemplate: "Download CSV template",
  required: "Required",
  invalidEmail: "Invalid email",
  cancel: "Cancel",
  invite: "Invite",
  userWillReceiveEmailInvitation:
    "The user will receive an email invitation to the platform to set up their account.",
  selectNewAccessLevel: "Select New Access Level",
  changeAccessLevelForSelectedUser:
    "Change the access level for the selected user. The user will keep access to In Progress courses.",
  youAreAboutToDeactivateUser: "You're about to deactivate a user.",
  youAreAboutToReactivateUser: "You're about to reactivate a user.",
  coursesWillBeNoLongerAvailable:
    "Any courses in progress will be no longer available for the user and all progress will be lost.",
  immediatelyGrantAccessLevel:
    "They will immediately be granted access to the Level of Access originally assigned to the user.",
  deactivateUser: "Deactivate User",
  confirm: "Confirm",
  resendInvite: "Resend Invite",
  deactivate: "Deactivate",
  reactivateUser: "Reactivate User",
  reactivate: "Reactivate",
  changeAccessLevel: "Change Access Level",
  topic: "Topic",
  creditHours: "Credit Hours",
  creditHoursShort: "Credit hours",
  instructor: "Instructor",
  accreditedBy: "Accredited By",
  profession: "Profession",
  professions: "Professions",
  states: "States",
  show: "Show",
  startTime: "Start Time",
  dayOfWeek: "Day of the Week",
  from: "From",
  to: "To",
  title: "Title",
  releaseDate: "Release Date",
  dateTime: "Date/Time",
  register: "Register",
  moreInformation: "More Information",
  modules: "{modulesCount} Modules",

  /* Organization Breaccrumbs*/
  organizationAdmin: "Organization Admin",
  organizationBreadcrumbsFetchFailed: "Unable to fetch organizations...",

  /* Enrollments */
  enrollmentDate: "Enrollment Date",
  user: "User",
  assignedBy: "Assigned by",
  startDate: "Start date",
  endDate: "End date",
  eventDate: "Event Date",
  courseTitle: "Course Title",
  credits: "Credits",
  selfUser: "Self-User",
  administrator: "Administrator",
  registerUsersButtonFormat: "Register ({usersCount}) users",
  registerUsersSelectedCountFormatKey: "{usersCount}",
  registerUsersDialogTitle: "Register users",
  registerAllUsersButton: "Register All Users",
  registerAllUsersDialogTitle: "Register All Users",
  registerAllUsersQueuedInfo:
    "Registration has started. All users in your Organization will be registered in the course shortly.",
  registerAllUsersWarning:
    "All users in your Organization will be registered in the course. Please confirm to proceed.",
  registerUsersWarning:
    "The selected users will be registered in the course. Please confirm to proceed.",
  usersRegisteredInfo: "The users have been registered successfully",
  usersRegisteredError:
    "The users have not been registered successfully due to an error",
  userAlreadyRegisteredTooltip: "User already registered",
  userPreviouslyCompletedTooltip:
    "This user has already completed this course in the past",
  registerUsersPriorCompletionWarning:
    "At least one of the selected users have already completed this course in the past.",
  showOnlyUsersNeverCompleted:
    "Show only users that have never completed this course",
  enrollUsers: "Enroll users",

  /* Accessible names for the catalog tables */
  liveOnlineCatalog: "Live Online Catalog",
  homeStudyCatalog: "Home Study Catalog",
  seriesCatalog: "Series Catalog",

  /* Certificates */
  completionDate: "Completion Date",
  certificates: "Certificates",
  viewCertificate: "View certificate",
  certificateType: "Certificate type",
  certificatesNotFound: "No certificates found",
  downloadCertificatesError: "Unable to download certificates for this user",
  bulkUploadCancelled: "There was an error, please refresh and try again.",
  examResults: "Exam Results",
  viewCertificates: "View Certificates",
  moreCertificateActions: "More certificate actions",
  examDate: "Exam Date",
  score: "Score",
  result: "Result",
  attemptNumber: "Attempt Number",
  noExamAttemptsFound: "No exam attempts found",
  examResultsFetchError: "Unable to load exam results",
  examResultFetchError: "Unable to load exam result",
  backToCertificates: "Back to Certificates",
  attemptProgress: "{current} of {total}",
  examScorePassed: "Score: {score} of 100",
  examScoreFailed: "Score: {score} of 100 — a score of {passingScore} is required to pass.",

  unexpectedExportError: "Unexpected export error",
  userExistsError:
    'A user with this email address already exists in your Organization. If you need to resend the email invite to this user, search for their email address and click the three dots in the far right corner and select "Resend Invite."',

  /* Import Users Stepper */
  chooseAnImportTypeToContinue:
    "What would you like to do? Choose an import type to continue.",
  addUsers: "Add Users",
  deactivateUsers: "Deactivate Users",
  uploadAFileToAddNewUsers:
    "Upload a file to add new users to your organization and assign them an access level.",
  uploadAFileToDeactivateExistingUsers:
    "Upload a file to deactivate existing users in bulk. They'll lose access immediately.",
  organizationHasNoUsersToDeactivate:
    "This organization has no users to deactivate.",
  everyMatchingUserWillBeDeactivated:
    "Every matching user in the file will be deactivated. Use the same First Name, Last Name and Email Address columns as the add-user template.",
  deactivateTheseUsers: "Deactivate these users?",
  deactivationCannotBeUndoneInBulk:
    "Every user matched in the file will be deactivated. Any In Progress courses will no longer be available to them, and all progress will be lost. This can't be undone in bulk.",
  usersAreBeingDeactivated:
    "Your file was uploaded. Users are being deactivated and you will receive a summary email when it finishes.",
  fileMustHaveExactlyThreeColumns:
    "The file must have exactly three columns: FirstName, LastName, Email.",
  selectFile: "Select file",
  fileUpload: "File upload",
  fileUploaded: "File uploaded",
  fileDetails: "File Details",

  /* File Upload Errors */
  fileEmptyOrNoRows: "The file is empty or has no rows to be processed",
  errorPleaseTryAgain: "There was an error. Please try again",

  /* Professions and Licenses */
  licenses: "Licenses",
  national: "National",
  state: "State",

  /* Error Page */
  sorryPageNotAvailable: "Sorry, this page isn't available",
  tryAgainLater:
    "Try again later in a few minutes. If this problem persists, get in contact with customer care.",
  details: "Details",
  operationId: "Operation ID",
  url: "Url",

  /* Left Menu */
  collapseMenu: "Collapse Menu",
  pleaseSelectClientOrg: "Please select a Client Organization in the header",

  /* Not Found Page */
  notFound: "Not Found",
  pageDoesNotExist: "The page you are looking for does not exist.",

  /* File Upload Progress */
  progress: "Progress",
  importCompletedSuccessfully: "Import completed successfully",

  /* Pending Invitations */
  pendingInvitationsBannerTitle:
    "{usersCount, plural, one {# user has} other {# users have}} a pending invitation",
  pendingInvitationsBannerDescription:
    "{usersCount, plural, one {This user hasn't} other {These users haven't}} accepted their invitation yet.",
  resendAllInvitations: "Resend All Invitations",
  resendPendingInvitationsTitle: "Resend pending invitations",
  resendPendingInvitationsDescription:
    "This will resend invitation emails to {usersCount, plural, one {the # user} other {all # users}} with a Pending status. Users who have already accepted are unaffected.",
  noPendingInvitationsRemain: "There are no pending invitations left to resend.",
  resendCountInvitations:
    "Resend {usersCount, plural, one {# Invitation} other {# Invitations}}",
  invitationsResentSuccess:
    "Resending invitations to {usersCount, plural, one {# user} other {# users}}.",
};

export default en;
